const state = () => ({
    web3: null,
    userAddress: null,
    tokenInstance: null,
    contractInstance: null,
});
export default state;
